var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{attrs:{"type":"button"},on:{"click":_vm.onClick}},_vm._l((3),function(item){return _c('span',{staticClass:"burger-item"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }